import { EditIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Radio,
  RadioGroup,
  Select,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { error } from "console";
import RichTextEditor from "./RichTextEditor";
import { useState } from "react";

export const EmailProperties = () => {
  const [showCC, setShowCC] = useState(false);
  const [showBCC, setShowBCC] = useState(false);
  const [toValue, setToValue] = useState("");
  const [toError, setToError] = useState("");
  //const [toValue, setToValue] = useState('');
  const [error, setError] = useState("");
  const [showAttachments, setShowAttachments] = useState(false);

  // const validateGmail = (input: string): boolean => {
  //   // Split the input by comma and trim each email.
  //   const emails = input
  //     .split(',')
  //     .map((email) => email.trim())
  //     .filter((email) => email !== '');
  //   // Regex for a Gmail address.
  //   const gmailRegex = /^[\w.-]+@gmail\.com$/i;
  //   // Every email must match the regex.
  //   return emails.every((email) => gmailRegex.test(email));
  // };

  // // Handle onBlur to validate the entered emails.
  // const handleBlur = () => {
  //   if (!validateGmail(toValue)) {
  //     setToError('Please enter only Gmail addresses separated by commas.');
  //   } else {
  //     setToError('');
  //   }
  // };

  // Regex to match a Gmail address (case-insensitive).
  const gmailRegex = /^[a-zA-Z0-9._%+-]+@gmail\.com$/i;

  // Handler for changes in the textarea.
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    let value = e.target.value;

    // Replace newline characters with a comma and a space.
    value = value.replace(/(\r\n|\n|\r)/g, ", ");

    // Optional: Remove duplicate commas and extra spaces.
    value = value.replace(/,\s*,/g, ", ").trim();

    setToValue(value);
    setError(""); // Clear error on change.
  };

  // On blur, validate that all entered emails are Gmail addresses.
  const handleBlur = () => {
    // Split by comma, trim, and filter out empty strings.
    const tokens = toValue
      .split(",")
      .map((token) => token.trim())
      .filter((token) => token !== "");
    const allValid = tokens.every((token) => gmailRegex.test(token));
    if (!allValid) {
      setError("Please enter only Gmail addresses separated by commas.");
    } else {
      setError("");
    }
  };
  return (
    <Flex direction="column" alignItems="center">
      {/* EMAIL CONFIGURATION */}
      <Box
        borderWidth="1px"
        borderColor="gray.200"
        mt={6}
        p={0} // We'll control padding inside
        //bg="gray.50"
        w="100%"
        maxW="740px"
      >
        {/* Heading Bar: Light gray with a bottom border */}
        <Box bg="#f2f2f2" p={2} borderBottom="1px solid #ccc" w="100%">
          <Text fontWeight="semibold" fontSize="md" textAlign="left">
            Email Configuration
          </Text>
        </Box>

        {/* Content Area */}
        <Box p={6}>
          {/* FROM */}

          {/* FROM Field */}
          <FormControl mb={4}>
            <FormLabel fontWeight="medium" mb={1}>
              <Text as="span" color="red.500">
                *{" "}
              </Text>
              From
            </FormLabel>
            <Select
              placeholder="Select sender"
              /* Match the screenshot's styling: thin border, no radius */
              borderColor="#ccc"
              borderWidth="1px"
              borderRadius="none"
              size="sm"
              _focus={{
                outline: "none",
                borderColor: "blue.500",
              }}
            >
              <option value="john@example.com">eizen@example.com</option>
              <option value="jane@example.com">eizen++@example.com</option>
            </Select>
          </FormControl>

          {/*TO*/}
          <FormControl mb={4}>
            <FormLabel fontWeight="medium" mb={1}>
              <Text as="span" color="red.500">
                *{" "}
              </Text>
              To
            </FormLabel>
            <Textarea
              placeholder="Type or paste Gmail addresses here (each on a new line or separated by commas)..."
              borderColor="#ccc"
              borderWidth="1px"
              borderRadius="none"
              size="sm"
              value={toValue}
              onChange={handleChange}
              onBlur={handleBlur}
              _focus={{
                outline: "none",
                borderColor: "blue.500",
              }}
            />
            {error && (
              <Text color="red.500" fontSize="sm" mt={1}>
                {error}
              </Text>
            )}
          </FormControl>
          {/* Add CC, BCC, Attachments Links */}
          <Flex mt={2} gap={4} mb={1}>
            <Text
              as="span"
              color="blue.600"
              cursor="pointer"
              onClick={() => setShowCC(!showCC)}
            >
              Add CC
            </Text>
            <Text
              as="span"
              color="blue.600"
              cursor="pointer"
              onClick={() => setShowBCC(!showBCC)}
            >
              Add BCC
            </Text>
            <Text
              as="span"
              color="blue.600"
              cursor="pointer"
              onClick={() => setShowAttachments(!showAttachments)}
            >
              Add Attachments
            </Text>
          </Flex>
          {/* Conditionally render the CC input field */}
          {showCC && (
            <FormControl mb={4}>
              <FormLabel fontWeight="medium" mb={1}>
                CC
              </FormLabel>
              <Input
                placeholder="Enter CC recipients"
                borderColor="#ccc"
                borderWidth="1px"
                borderRadius="none"
                size="sm"
                _focus={{
                  outline: "none",
                  borderColor: "blue.500",
                }}
                //onClick={() => setShowCC(!showCC)}
              />
            </FormControl>
          )}

          {/* Conditionally render the BCC input field */}
          {showBCC && (
            <FormControl mb={4}>
              <FormLabel fontWeight="medium" mb={1}>
                BCC
              </FormLabel>
              <Input
                placeholder="Enter BCC recipients"
                borderColor="#ccc"
                borderWidth="1px"
                borderRadius="none"
                size="sm"
                _focus={{
                  outline: "none",
                  borderColor: "blue.500",
                }}
              />
            </FormControl>
          )}

          {/* Conditionally render the Attachments field */}
          {showAttachments && (
            <FormControl mb={4}>
              <FormLabel fontWeight="medium" mb={1}>
                Attachments
              </FormLabel>
              <Input
                type="file"
                multiple
                borderColor="#ccc"
                borderWidth="1px"
                borderRadius="none"
                size="sm"
                _focus={{
                  outline: "none",
                  borderColor: "blue.500",
                }}
              />
            </FormControl>
          )}

          {/* REPLY TO */}
          {/* <FormControl mb={4}>
          <FormLabel fontWeight="medium" mb={1}>
            Reply To
          </FormLabel>
          <InputGroup>
            <Input placeholder="Enter reply-to email" />
            <InputRightElement>
              <EditIcon color="gray.400" />
            </InputRightElement>
          </InputGroup>
        </FormControl> */}

          {/* SUBJECT */}
          <FormControl mb={4}>
            <FormLabel fontWeight="medium" mb={1}>
              Subject
            </FormLabel>
            <InputGroup>
              <Input placeholder="Enter subject" />
              <InputRightElement>
                <EditIcon color="gray.400" />
              </InputRightElement>
            </InputGroup>
          </FormControl>

          {/* PRIORITY */}
          <FormControl mb={2}>
            <FormLabel fontWeight="medium" mb={1}>
              Priority
            </FormLabel>
            <InputGroup>
              <Select defaultValue="Normal">
                <option value="Normal">Normal</option>
                <option value="High">High</option>
                <option value="Low">
                  Low
                  <InputRightElement>
                    <EditIcon color="gray.400" />
                  </InputRightElement>
                </option>
              </Select>
              {/* <InputRightElement>
              <EditIcon color="gray.400" />
            </InputRightElement> */}
            </InputGroup>
          </FormControl>

          {/* Required Note */}
          <Text color="red.500" fontSize="sm" mt={3}>
            * Required
          </Text>
        </Box>
      </Box>

      {/* MESSAGE BODY */}
      <Box
        borderWidth="1px"
        borderColor="gray.200"
        mt={6}
        p={6}
        //bg="gray.50"
        w="100%"
        maxW="740px"
      >
        <Text fontWeight="semibold" fontSize="md" mb={4} textAlign="left">
          Message Body
        </Text>

        <RadioGroup defaultValue="text">
          <Flex mb={4} gap={6}>
            <Radio value="text">Enter text here</Radio>
            <Radio value="template">Use a text or HTML template</Radio>
          </Flex>
        </RadioGroup>

        <HStack mb={1} spacing={2} color="blue.500" fontSize="sm">
          <Button variant="link" colorScheme="blue">
            Use Header Template
          </Button>
          <Text>|</Text>
          <Button variant="link" colorScheme="blue">
            Use Footer Template
          </Button>
        </HStack>

        {/*text are */}
        <RichTextEditor></RichTextEditor>
        <Flex justify="space-between" mt={4}>
          <Button variant="outline">CANCEL</Button>
          <Button colorScheme="blue">OK</Button>
        </Flex>
      </Box>
    </Flex>
  );
};
